var _ellipse, _ellipse2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtn5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 49,
    viewBox: "0 0 76 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8507,
    cy: 24.4975,
    rx: 37.1912,
    ry: 24.4399,
    fill: "url(#paint0_linear_1833_3245)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8393,
    cy: 18.3641,
    rx: 33.8393,
    ry: 18.3065,
    fill: "url(#paint1_linear_1833_3245)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1833_3245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4971 14.9769H30.9609L29.2998 18.1215H29.2041L27.5293 14.9769H24.877L27.6592 19.6117L24.8701 24.308H27.29L29.0537 21.2455H29.1494L30.9131 24.308H33.4629L30.5986 19.639L33.4971 14.9769ZM34.5156 19.8314C34.5742 22.4447 36.707 24.601 40.5508 24.601C44.2891 24.601 46.9609 22.3978 46.9609 18.8002C46.9609 15.4955 44.4648 13.5385 41.6992 13.5385C39.7422 13.5385 38.6289 14.3939 38.2773 14.9095H38.125L38.4531 11.3353H45.8125V8.30017H35.4063L34.7266 17.7806H38.1602C38.4531 17.1595 39.25 16.3627 40.6094 16.3627C42.1094 16.3627 43.2109 17.4291 43.2109 18.9877C43.2109 20.6166 41.9688 21.6244 40.6094 21.6244C39.2031 21.6244 38.1953 20.8978 38.0313 19.8314H34.5156Z",
    fill: "#623B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1833_3245",
    x: 24.8701,
    y: 8.30017,
    width: 23.0908,
    height: 17.3008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1833_3245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1833_3245",
    x1: 37.8507,
    y1: 0.0576172,
    x2: 37.8507,
    y2: 48.9374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFDC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB8213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1833_3245",
    x1: 20.3853,
    y1: 3.71892,
    x2: 32.3824,
    y2: 41.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtn5);
export default __webpack_public_path__ + "static/media/btn5.6f670daebdc4fbba0cc7fd7857baf73c.svg";
export { ForwardRef as ReactComponent };